import { User } from "oidc-client-ts";
import { doPost } from "./util/apiHelper.ts";
import { useAuthenticatedMutation } from "./util/queryHelper.ts";

interface CreatePaymentResponseDto {
  sessionSecret: string;
}

const postPayment = async (bookingId: string, user: User) => {
  return doPost<CreatePaymentResponseDto>(
    `/users/${user.profile.sub}/payments/${bookingId}`,
    user,
  );
};

export function usePaymentMutation() {
  return useAuthenticatedMutation(postPayment);
}
